import { makeAutoObservable } from "mobx";

import {
  type AdminCountry,
  type AdminCountryCode,
  DEFAULT_ADMIN_COUNTRY_CODE,
  findAdminCountry,
} from "@/config/adminCountries";

const STORAGE_KEY = "admin-country-filter";

const readSavedCountryCode = (): AdminCountryCode => {
  try {
    const saved = findAdminCountry(localStorage.getItem(STORAGE_KEY));
    return saved?.code ?? DEFAULT_ADMIN_COUNTRY_CODE;
  } catch {
    // Storage can be blocked (private window). The filter still works for the
    // session, it is just not remembered.
    return DEFAULT_ADMIN_COUNTRY_CODE;
  }
};

/**
 * The country the whole admin is looking at. Every admin report and list reads
 * its currency from here, so one choice moves every screen. The choice is kept
 * in the browser.
 */
export class CurrencyFilterStore {
  countryCode: AdminCountryCode = readSavedCountryCode();

  constructor() {
    makeAutoObservable(this);
  }

  get country(): AdminCountry {
    return (
      findAdminCountry(this.countryCode) ??
      findAdminCountry(DEFAULT_ADMIN_COUNTRY_CODE)!
    );
  }

  get currency(): string {
    return this.country.currency;
  }

  setCountry(code: AdminCountryCode) {
    this.countryCode = code;
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch {
      // Not remembered, see above.
    }
  }
}
